"use client";

import { L } from "@/extensions/lida/lida";
import { T } from "@/lib/i18n/T";
import { findCategorySubmenu } from "@/components/layout/navMenus";

/**
 * A category name coming from the backend.
 *
 * Two tiers on purpose: a category the nav already names (Dresses, Tops, …)
 * renders from its message id and is correct instantly and offline, while the
 * ~130 deeper ones the nav does not name fall back to WorldLida. Without this
 * an Italian page lists its categories in English.
 */
export function FacetLabel({
  section,
  value,
  label,
}: {
  section?: string;
  value: string;
  label: string;
}) {
  const known = section ? findCategorySubmenu(section, value) : null;
  return known ? <T id={known.titleId} /> : <L text={label} />;
}
